:host {
  @apply inline-flex flex-col;
}
